<div class="tabs-1" [class.tabs-2]="isTab">
	<i class="material-icons" [hidden]="isTab" (click)="isTab=true">tablet</i>
	<i class="material-icons" [hidden]="!isTab" (click)="isTab=false">smartphone</i>
	<div class="preview_phone" [class.preview_tab]="isTab">
		<iframe id="iframeMain" #iframeMain width="100%" height="100%" frameBorder="0" [src]="iframe_html" (load)="onload($event)" [height]="iframeHeight"></iframe>
	</div>
</div>
